import React from 'react';
import { FieldDisplayProps } from '../types';
import {
  TextFieldDisplay,
  EmailFieldDisplay,
  PhoneFieldDisplay,
  UrlFieldDisplay,
  PersonFieldDisplay,
  DateFieldDisplay,
  NumberFieldDisplay,
  SelectFieldDisplay,
  MultiSelectFieldDisplay,
  BooleanFieldDisplay,
} from './display';

/**
 * FieldDisplay - Router component that renders the appropriate display component
 * based on field type. Similar to Twenty CRM's FieldDisplay pattern.
 */
export const FieldDisplay: React.FC<FieldDisplayProps> = (props) => {
  const { fieldDefinition } = props;
  const fieldType = fieldDefinition.type;

  switch (fieldType) {
    case 'email':
      return <EmailFieldDisplay {...props} />;

    case 'phone':
      return <PhoneFieldDisplay {...props} />;

    case 'url':
      return <UrlFieldDisplay {...props} />;

    case 'person':
      return <PersonFieldDisplay {...props} />;

    case 'date':
      return <DateFieldDisplay {...props} />;

    case 'number':
      return <NumberFieldDisplay {...props} />;

    case 'select':
      return <SelectFieldDisplay {...props} />;

    case 'multiselect':
      return <MultiSelectFieldDisplay {...props} />;

    case 'boolean':
      return <BooleanFieldDisplay {...props} />;

    case 'text':
    default:
      return <TextFieldDisplay {...props} />;
  }
};

export default FieldDisplay;
